/**
 *
 * FreshPets Space
 *
 */
const space = [0, 6, 12, 18, 24, 42, 84, 168, 336]

export default space
